import axios from "axios";
import { apiURL, baseURL } from "utils/config";
import { getAuthorizationHeaders } from "./auth";
import store from "../store";

export const getNotificationsInfo = () => {
  let schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/comments`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};

export const markCommentAsRead = (cid, type, field_user_reference) => {
  return axios({
    url: `${baseURL}/comment/${cid}`,
    method: "PATCH",
    data: { comment_type: type, field_user_reference: field_user_reference },
    headers: getAuthorizationHeaders(),
  });
};

export const getTeacherComments = () => {
  let schoolId = store.getState().user.selectedSchool?.id;
  if (!schoolId) return Promise.resolve({ data: null });
  return axios({
    url: `${apiURL}/school/${schoolId}/comments-teacher`,
    method: "GET",
    headers: getAuthorizationHeaders(),
  });
};
